export const actionTypes = {
  SET_ISMOBILE: "SET_ISMOBILE",
  SET_MESSAGE: "SET_MESSAGE",
  SET_CURMENU: "SET_CURMENU",
  SET_CURURL: "SET_CURURL",
  SET_PROVINCE: "SET_PROVINCE",
  SET_CITY: "SET_CITY",
  SET_COUNTY: "SET_COUNTY",
  SET_INTER_MENU_INDEX: "SET_INTER_MENU_INDEX",
  SET_IS_WIDE_SCREEN: "SET_IS_WIDE_SCREEN",
  SET_CITY_LIST_ARRAY: 'SET_CITY_LIST_ARRAY',
  SET_COUNTY_LIST_ARRAY: 'SET_COUNTY_LIST_ARRAY',
  CLEAR_COUNTY_LIST_ARRAY: 'CLEAR_COUNTY_LIST_ARRAY',
  TOGGLE_LIST_SHOW: 'TOGGLE_LIST_SHOW',
  SET_CURRENT_TIME: 'SET_CURRENT_TIME',
  SET_AUTH_MATERIAL_LIST: 'SET_AUTH_MATERIAL_LIST',
  TOGGLE_SOLUTION_LIST_SHOW: "TOGGLE_SOLUTION_LIST_SHOW",
  SET_CURR_MENU_PATH: "SET_CURR_MENU_PATH",
  SET_SEARCH_GLOBAL: "SET_SEARCH_GLOBAL",
  SET_ALL_DEPT: "SET_ALL_DEPT",
  SET_USER_BY_DEPT: "SET_USER_BY_DEPT",
  SET_BEFOUR_LOGIN_URL: "SET_BEFOUR_LOGIN_URL",
};